const TRANSLATION = {
  buyModal: {
    afterFree: 'Після вашої безкоштовної пробної версії',
    btn: 'Спробуйте безкоштовно',
    freeTrial: '3-денна безкоштовна пробна версія',
    monthLabel: 'місяць',
    selectLabel: 'Виберіть план',
    title: 'План передплати',
    yearLabel: 'рік',
  },
  contact: {
    block1:
      "Для налаштування, питань чи пропозицій, будь ласка, зв'яжіться з нами за адресою contact@noam.tools. Ми відповімо негайно.",
    block2: 'Підтримуйте нас, оцінивши нас у магазині розширення додатків Google за адресою ★★★★★.',
    block3: 'Допоможіть іншим, поділившись цим розширенням:',
    title: 'Зв’яжіться з нами',
  },
  help: {
    AquickOverviewOfNoam: 'Швидкий огляд Ноама',
    ChatPDF: 'Чат PDF',
    ChatPDF2: 'Чатпдф',
    FavoritesManagement: 'Управління улюбленими',
    Fixedplugin: 'Фіксований плагін',
    Focusing: 'Фокусування',
    Free: 'Безкоштовний',
    FreeTrialBenefits: 'Безкоштовні випробування проб',
    GoWithWikipedia: 'Ідіть з Вікіпедії',
    GoWithYouTube: 'Ідіть з YouTube',
    HoverTranslation: 'Переклад наведення',
    Howtouse: 'Як користуватися',
    ImageTranslation: 'Переклад зображення',
    InstantTranslation: 'Миттєвий переклад',
    Membership: 'Членство',
    NoamHelp: 'Ноам допомагає вам перекладати та узагальнити',
    PDFparallelTranslation: 'PDF Паралельний переклад',
    ParallelTranslation: 'Паралельний переклад',
    SkipAllSteps: 'Пропустити всі кроки',
    Summary: 'Резюме',
    Translation: 'Переклад',
    TryItForFree: 'Спробуйте безкоштовно',
    Video: 'Відео',
    VideoSummary: 'Резюме відео',
    VideoTranslation: 'Переклад відео',
    WebSummary: 'Веб -резюме',
    WordSelectionTranslation: 'Переклад відбору слів',
    benefits: 'Ми маємо користь на вас чекати!',
    dayFree: '3-денна безкоштовна пробна версія',
    done: 'Зроблений',
    next: 'Наступний',
    pin: 'Приводьте Ноам для легшого доступу ～～',
    planIsNotExist: 'План недоступний',
    startWiki: 'Почнемо з Wikimedia!',
    startYoutube: 'Почнемо з YouTube!',
    try: 'Спробуйте',
    tryNow: 'Спробуйте зараз!',
  },
  home: {
    PDFTranslate: {
      desc: 'Двомовний переклад + чат PDF',
      sub1: {
        desc: 'Двомовне читання дозволяє порівнювати оригінальний текст та переклад, що покращує ефективність читання.',
        title: 'Двомовне читання',
      },
      sub2: {
        desc: 'AI аналізує та підсумовує, і може відповісти на ваші запитання на основі вмісту PDF.',
        title: 'Чат PDF',
      },
      sub3: {
        desc: 'Переклад PDF, що працює на AI, для більшої точності та ефективності.',
        title: 'Точність та ефективність',
      },
      title: 'PDF Translate',
    },
    aiAssistant: {
      desc: 'Зробити веб -переклад розумнішим та зручнішим',
      panel1: {
        desc: 'Двомовні переклади перехресного посилання допомагають вам порівняти оригінальний текст з перекладом, щоб ви могли краще зрозуміти та підвищити ефективність читання.',
        title: 'Двомовний переклад',
      },
      panel2: {
        left: {
          desc: 'Під час перегляду веб -сторінки наведіть курсор на вміст, який потрібно перекласти, щоб побачити переклад.',
          title: 'Переклад наведення',
        },
        right: {
          desc: 'Переглядаючи веб -сторінку, виберіть текст, який потрібно перекласти, щоб побачити переклад.',
          title: 'Переклад вибору тексту',
        },
      },
      panel3: {
        one: {
          desc: 'Перекладіть та підсумовуйте веб -сторінки та відеоконтент у будь -який час і де завгодно, для більш плавного досвіду!',
          title: 'Точка і натисніть',
        },
        three: {
          desc: 'Велика мовна модель, орієнтована на AI, забезпечує точність перекладу та послідовність для покращеного досвіду читання.',
          title: 'AI-керований',
        },
        two: {
          desc: "Багатомовне повне висвітлення, двомовне читання без бар'єрів, переклад на один клік-відчувайте різницю!",
          title: 'Більш всебічний і зручний',
        },
      },
      panel4: {
        tab1: {
          desc: 'Ваш експерт з ефективності - використовуючи Chatgpt, Noam перекладає та підсумовує відео вміст YouTube, щоб заощадити ваш час!',
          key: 'Відео',
          title: 'Переклад та резюме відео',
        },
        tab2: {
          desc: 'Клацніть, щоб перекласти зображення під час перегляду Інтернету.',
          key: 'Зображення',
          title: 'Зображення Перекладіть',
        },
        tab3: {
          desc: 'Миттєво витягує ключову інформацію з веб -сторінок та надає резюме, підвищуючи ефективність читання.',
          key: 'Павутина',
          title: 'Веб -переклад та підсумок',
        },
        tag1: 'Простий',
        tag2: 'Ефективний',
        tag3: 'Легко зрозуміти',
      },
      title: 'AI Assistant',
    },
    getStart: 'Розпочати',
    getStartedForFree: 'Почніть безкоштовно',
    howItWork: {
      desc: 'NOAM інтегрує моделі AI, щоб надати користувачам інтелектуальний досвід для переходу та узагальнення веб-сторінок, PDF та перекладу зображень, переклад та узагальнення відео та узагальнення',
      title: 'Як це працює',
    },
    lastBlock: { desc: 'Кращий переклад AI для більш плавного досвіду читання' },
    top: {
      desc: 'Noam - це безкоштовне розширення браузера AI, яке допомагає вам перекладати та узагальнити веб -сторінки, відео та PDF -вміст.',
      title1: 'Одна магія',
      title2: 'Один клацання',
    },
    userReviews: {
      desc: "П'ятизіркові відгуки в веб-магазині Chrome",
      title: 'Відгуки користувача',
    },
  },
  installTips: {
    btn: 'Спробуйте зараз',
    text: 'Встановіть "плагін браузера Noam", щоб розблокувати більше функцій! Веб-перехресне відношення, \\ n Веб-відео підсумки та багато іншого!',
  },
  locale: {
    af: 'Африкаани',
    am: 'Амхарський',
    ar: 'Арабський',
    as: 'Асамський',
    auto: 'Автоматичне виявлення',
    az: 'Азербайджані',
    ba: 'Башкір',
    bg: 'Болгарський',
    bn: 'Бангла',
    bo: 'Тибетський',
    bs: 'Боснійський',
    ca: 'Каталонський',
    cs: 'Чеський',
    cy: 'Валлійський',
    da: 'Датський',
    de: 'Німецький',
    dsb: 'Нижня сорбська',
    dv: 'Дайвхі',
    el: 'Грецький',
    en: 'Англійська мова',
    es: 'Іспанська мова',
    et: 'Естонський',
    eu: 'Баска',
    fa: 'Перський',
    fi: 'Фінський',
    fil: 'Філіппінський',
    fj: 'Фіджіан',
    fr: 'Французький',
    frCA: 'Французька (Канада)',
    ga: 'Ірландський',
    gl: 'Галійка',
    gom: 'Конкані',
    gu: 'Гуджараті',
    ha: 'Хауса',
    he: 'Іврит',
    hi: 'Хінді',
    hr: 'Хорватський',
    hsb: 'Верхній сорбський',
    ht: 'Гаїтян Креоль',
    hu: 'Угорський',
    hy: 'Вірменський',
    id: 'Індонезійський',
    ig: 'Igbo',
    ikt: 'Inuinnaqtun',
    is: 'Ісландський',
    it: 'Італійський',
    iu: 'Inuktitut',
    iuLatn: 'Inuktitut (латинська)',
    ja: 'Японський',
    ka: 'Грузинський',
    kk: 'Казаха',
    km: 'Кхмер',
    kmr: 'Курдський (північний)',
    kn: 'Канада',
    ko: 'Корейський',
    ku: 'Курдський (центральний)',
    ky: 'Киргиз',
    ln: 'Лінгала',
    lo: 'Лао',
    lt: 'Литовський',
    lug: 'Ганда',
    lv: 'Латвійський',
    lzh: 'Китайський (літературний)',
    mai: 'Мейтілі',
    mg: 'Малагасійський',
    mi: 'Маорі',
    mk: 'Македонський',
    ml: 'Малаялам',
    mnCyrl: 'Монгольський (Кириллік)',
    mnMong: 'Монгольський (традиційний)',
    mr: 'Маратхі',
    ms: 'Малайський',
    mt: 'Мальтійський',
    mww: 'Hmong Daw',
    my: "М'янма (бірманці)",
    nb: 'Норвезький',
    ne: 'Непальський',
    nl: 'Голландський',
    noSearchLang: 'Мова не підтримується',
    nso: 'Sesotho Sa Leboa',
    nya: 'Нянья',
    or: 'Ода',
    otq: 'Querétaro Otomi',
    pa: 'Пенджабі',
    pl: 'Польський',
    placeholder: 'Обшук',
    prs: 'Дарі',
    ps: 'Шпилька',
    pt: 'Португальська (Бразилія)',
    ptPT: 'Португальська (Португалія)',
    ro: 'Румунський',
    ru: 'Російський',
    run: 'Рунді',
    rw: 'Kinyarwanda',
    sd: 'Сіндхі',
    si: 'Сингала',
    sk: 'Словак',
    sl: 'Словенський',
    sm: 'Самоанський',
    sn: 'Шона',
    so: 'Сомалі',
    sq: 'Албанський',
    srCyrl: 'Сербський (Кириллік)',
    srLatn: 'Сербський (латинський)',
    st: 'Сесото',
    sv: 'Шведський',
    sw: 'Суахілі',
    ta: 'Тамільський',
    te: 'Телугу',
    th: 'Тайський',
    ti: 'Тигрина',
    tk: 'Туркмен',
    tlhLatn: 'Клінгон (латинська)',
    tlhPiqd: 'Klingon (Piqad)',
    tn: 'Сетсвана',
    to: 'Тонган',
    tr: 'Турецький',
    tt: 'Татар',
    ty: 'Таїтянський',
    ug: 'Уйгур',
    uk: 'Український',
    ur: 'Урду',
    uz: 'Узбек (латинська)',
    vi: "В'єтнамський",
    xh: 'Xhosa',
    yo: 'Йоруба',
    yua: 'Юкатек Майя',
    yue: 'Кантонський (традиційний)',
    zh: 'Китайський',
    zhHans: 'Китайська спрощена',
    zhHant: 'Китайський традиційний',
    zu: 'Зулу',
  },
  login: {
    and: 'і',
    btn: 'Увійдіть у Google',
    btn1: 'Увійдіть зараз',
    desc: 'Увійдіть, щоб розблокувати більше досвіду',
    policy: 'Політика конфіденційності',
    terms: 'Умови використання',
    tips: 'Підписавшись, я згоден на',
    title: 'Ласкаво просимо до Ноама',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Дотримуватися', twitter: 'Твіттер' },
    legal: {
      policy: 'Політика конфіденційності',
      terms: 'Умови обслуговування',
      title: 'Юридичний',
    },
    product: {
      image: 'Переклад зображення',
      pdf: 'Переклад PDF',
      title: 'Продукція',
      video: 'Переклад та резюме відео',
      web: 'Веб -переклад та підсумок',
    },
    resources: { title: 'Ресурси' },
    tools: { title: 'Інструменти', pdf: 'PDF переклад' },
  },
  pageHeader: {
    contact: 'Контакт',
    help: 'Допомога',
    logout: 'Виходити',
    logoutSucc: 'Вийшов.',
    pricing: 'Ціноутворення',
    settings: 'Налаштування',
    signUp: 'Увійти',
  },
  pdf: {
    autoDetect: 'Автоматичне виявлення',
    cancelBtn: 'Скасувати',
    cancelUpload: 'Скасувати',
    chatPdf: {
      summaryError: 'Короткий зміст не вдався, спробуйте ще раз пізніше',
      chatError: 'Чат не вдався, спробуйте ще раз пізніше',
      Search: 'Обшук',
      cancel: 'Скасувати',
      chatTitle: 'Ласкаво просимо до Ноама! Ось резюме вашого PDF:',
      clear: 'Чіткий',
      clearContent: 'Це розпочне нову розмову. Поточна розмова не буде збережена. Ви впевнені?',
      clearDialogTitle: 'Будь ласка, підтвердьте',
      clearSucc: 'Очищений',
      copy: 'Копіювати',
      copySucc: 'Скопійований',
      delete: 'Видаляти',
      deleteCancel: 'Скасувати',
      deleteContent: 'Цей PDF не може бути відновлений після видалення. Ви впевнені?',
      deleteOk: 'Видаляти',
      deleteSuccess: 'Видалений',
      deleteTitle: 'Підтвердьте видалення',
      expand: 'Колапс',
      historyTitle: 'Історія',
      listError:
        'Не вдалося завантажити список читання. Будь ласка, спробуйте пізніше або зв’яжіться з підтримкою.',
      loading: 'Завантаження ...',
      noDataDesc: 'Ще немає історії.',
      noMore: 'Більше немає вмісту.',
      placeholder: 'Запитайте що -небудь про цей PDF',
      summaryTitle: 'Ви можете зацікавити ці питання:',
    },
    collectionEmpty: 'Ваша колекція порожня.',
    collectionTab: 'Нотатки',
    dataLoading: 'Завантаження ...',
    dialogContent: 'Ви впевнені, що хочете видалити це?',
    dialogTitle: 'Будь ласка, підтвердьте',
    download: {
      both: 'Двомовний',
      btn: 'Заощадити',
      cancel: 'Закриття цього вікна скасує завантаження PDF. Ви впевнені, що хочете скасувати?',
      desc: 'Зберегти на пристрої: завантажує переклади як зображення; Зберегти та друкувати: завантажує переклади в оригінальному форматі, із підтримкою копіювання.',
      download: 'Завантажувати',
      downloadMsg1: 'PDF -прогрес у перекладі:',
      downloadMsg2: 'Орієнтовний час, що залишився:',
      downloadSucc: 'PDF готовий! Клацніть, щоб зберегти.',
      downloadTip: 'Завантаження PDF. Не закривайте це вікно, щоб уникнути помилок завантаження.',
      error: 'Не вдалося зберегти. Спробуйте надрукувати замість цього.',
      fileName: 'Назва файлу:',
      fileType: 'Тип файлу:',
      loading: 'Збереження ...',
      loading2: 'Завантаження ...',
      minute: 'Хвилини ...',
      msg1: 'Деякі переклади в цьому документі довші, ніж оригінальний текст, і можуть перетинатися у завантаженому файлі. Ми рекомендуємо прочитати на веб -сторінці.',
      msg2: '1. Переклад ще не завершений. Завантажте після закінчення перекладу.',
      msg3: '2. Деякі переклади занадто довгі. Читайте на веб -сторінці, щоб уникнути перекриття тексту.',
      msg4: 'Завдання перекладу тривають. Будь ласка, спробуйте ще раз після їх завершення.',
      progress:
        'Переклад PDF. Прогрес: {{прогрес}}, орієнтовний час, що залишився: {{хвилини}} хвилини ...',
      save: 'Зберегти на пристрої',
      savePrint: 'Зберегти та друкувати',
      success: 'Завантажений',
      trans: 'Тільки переклад',
      transContinue: 'Продовжуйте перекладати',
    },
    downloadBtn: 'Завантажувати',
    dragTipModal: {
      black: 'простір',
      leftKey: 'ліва кнопка',
      ok: 'Отримав',
      press: 'Пресувати',
      tips: 'перетягувати та переглядати.',
    },
    entry: 'PDF -файли',
    fileErrMsg:
      'Читання файлів не вдалося. Будь ласка, спробуйте пізніше або зв’яжіться з підтримкою.',
    fileMsg: 'Поточний розмір файлу:',
    fileMsg2: 'Завантажте файл менше 300 Мб.',
    freeBannerBtn: 'Оновлення',
    freeBannerTips: 'Безкоштовний обмеження перекладів PDF',
    guide: {
      placeholder: 'Вставте тут посилання PDF',
      start: 'Почніть перекладати',
      text1: 'Двомовне читання',
      text2:
        'Прочитайте двомовно, щоб порівняти оригінальний текст та переклад поруч, підвищення ефективності.',
      text3: 'Поспілкуватися зі своїм PDF',
      text4:
        'Аналіз та узагальнення AI. Задайте питання щодо свого PDF та отримайте миттєві відповіді.',
      text5: 'Точний та ефективний',
      text6: 'Переклад PDF, що працює на AI, для більшої точності та ефективності.',
      title1: 'Двомовний переклад',
      title2: 'Поспілкуватися зі своїм PDF',
      toast: 'Введіть дійсне онлайн -посилання PDF, що закінчується в .pdf',
    },
    hasTransTask: 'Завдання перекладу триває. Зачекайте.',
    hoverTrans: 'Трансляції абзаців',
    initial: 'Перекласти PDF',
    installText: 'Ваше єдине рішення для повсякденних перекладів.',
    installText2: 'Будь ласка, встановіть розширення спочатку',
    installTips:
      'Встановіть розширення для ще більшої кількості перекладів PDF та більш плавних перекладів веб -сайтів:',
    kw: 'шаблон',
    link: "зв'язок",
    listError:
      'Не вдалося завантажити PDF -файли. Будь ласка, спробуйте пізніше або зв’яжіться з підтримкою.',
    memoTotalCount: '1 пункт Всього',
    new: 'новий файл',
    noId: 'Ідентифікатор файлу не знайдено.',
    notPdf: 'Тільки PDF -файли.',
    okBtn: 'Видаляти',
    okBtn2: 'Отримав',
    original: 'Оригінальний',
    parallel: 'Паралельний',
    parseErrDialogContent:
      'Це посилання PDF неможливо перекласти безпосередньо. Завантажте PDF та завантажте його для перекладу.',
    parseErrTips: 'Не вдалося розібрати файл',
    parseFileToast:
      'Не вдалося розібрати файл. Будь ласка, спробуйте пізніше або зв’яжіться з підтримкою.',
    pdfLoading: 'Розбір ...',
    searchPlaceholder: 'Пошук',
    selectTrans: 'Виберіть текст для перекладу',
    shareBtn: 'Розподіляти',
    shareBtnText1: 'Генерувати посилання на частку',
    shareBtnText2: 'Оновити спільний вміст',
    shareModal: {
      cancel: 'Скасувати',
      copy: 'Копіювати',
      copySucc: 'Посилання скопійовано',
      custom: 'Налаштуйте:',
      errMsg:
        'Вибраний вміст ще не був повністю перекладений. Будь ласка, перекладіть перед обміном.',
      gen: 'Розподіляти',
      modify: 'Редагувати',
      notSupport: 'Ця мова наразі не підтримується.',
      page: 'Сторінки',
      pageNuErr: 'Введіть дійсний номер сторінки.',
      range: 'Обсяг:',
      remain: 'що залишився',
      remain1: 'Загальний орієнтовний час:',
      search: 'Пошук',
      settings: 'Поділитися налаштуваннями:',
      shareSetting: 'Поділитися налаштуваннями',
      shareText: 'Розподіляти',
      shareTips: 'Поділіться перекладеним посиланням PDF з друзями:',
      sourceLang: 'Від:',
      target: 'До:',
      text1: 'Поділитися налаштуваннями',
      text2: 'Генерувати посилання на частку',
      totalPage: 'Всього 1 сторінки',
      trans: 'Перекладати',
      translateTips:
        'Порада: Якщо переклад займає деякий час, ви можете закрити це вікно і поділитися пізніше.',
      translating: 'Переклад PDF ...',
      update: 'Посилання на оновлення спільної роботи',
    },
    shareMsg1: 'Поділитися генерованим посиланням.',
    shareMsg2: 'Спільний вміст оновлений.',
    shareMsg3:
      'Не вдалося створити посилання на акцію. Будь ласка, спробуйте пізніше або зв’яжіться з підтримкою.',
    shareMsg4:
      'Не вдалося оновити спільний вміст. Будь ласка, спробуйте пізніше або зв’яжіться з підтримкою.',
    shareTips: 'Ваш переклад PDF готовий! Поділіться ним зі своїми друзями.',
    start: 'Почніть свою безкоштовну пробну версію',
    thumbnail: 'Зміст',
    toast1: 'Завантаження PDF. Будь ласка, спробуйте пізніше.',
    toast2: 'Вміст PDF занадто великий. Наразі діалог не підтримується.',
    toast3: 'Завантаження. Будь ласка, спробуйте ще раз після закінчення завантаження.',
    toolbar: { Adjust: 'Відрегулювати', autoFit: 'Автоматичний' },
    trans: 'Переклад',
    transSucc: 'Переклад успішний!',
    unLoginToast: 'Будь ласка, увійдіть, щоб використовувати цю функцію.',
    uploadBtn: 'Завантажувати',
    uploadErr:
      'Не вдалося завантажити файл. Будь ласка, спробуйте пізніше або зв’яжіться з підтримкою.',
    uploadErrSignUrl:
      'Не вдалося отримати URL -адресу для завантаження. Будь ласка, спробуйте пізніше або зв’яжіться з підтримкою.',
    uploadMsg1: 'Перетягніть і киньте файл тут.',
    uploadMsg2: 'Підтримувані типи файлів: PDF |  Максимальний розмір файлу: 300 Мб',
    uploadMsg3: 'Клацніть, щоб вибрати або перетягнути файли тут.',
    uploading: 'Завантаження',
    uploadingMsg: 'Завантаження. Зачекайте.',
    uploadingMsg1: 'Файл завантажується. Будь ласка, спробуйте пізніше.',
    uploadingMsg2: 'Наразі перетворюється файл. Будь ласка, спробуйте пізніше.',
    uploadingMsg3:
      'Помилка запиту про хід конверсії. Будь ласка, спробуйте пізніше або зв’яжіться з підтримкою.',
    uploadingMsg4:
      'Noam не може отримати доступ до локальних файлів. Будь ласка, вручну завантажте PDF для перекладу.',
    uploadingMsg5:
      'Не вдалося отримати URL -адресу файлу. Будь ласка, спробуйте пізніше або зв’яжіться з підтримкою.',
    video: 'відео',
    vipBannerBtn: 'Оновлення',
    vipBannerTips: 'Ви досягли свого ліміту перекладу PDF за цей місяць.',
    webTrans: 'Повне перехресне посилання',
  },
  pricing: {
    FAQ: 'Поширення',
    FQAObj: {
      a1: 'Так, Noam пропонує безкоштовний план, яким ви можете використовувати відразу.',
      a2: 'Ми пропонуємо три плани членства: Pro, Pro+та Enterprise. Ви можете платити щомісяця або щорічно. Щорічні виставлення рахунків пропонують значні заощадження.',
      a3: 'Усі функції доступні в обох планах. Основна відмінність - вартість: щорічні підписки коштують дешевше. Щомісячні підписки виставляють рахунок щомісяця, тоді як річні плани виставляються один раз на рік.',
      a4: 'Ви можете скасувати підписку в будь -який час у налаштуваннях свого облікового запису.',
      q1: 'Чи є безкоштовний план?',
      q2: 'Які плани ціноутворення та варіанти оплати доступні?',
      q3: 'Яка різниця між підписанням щомісяця проти щорічно?',
      q4: 'Як скасувати підписку?',
    },
    around: 'Навколо',
    billedMonthly: 'Виставлений щомісяця',
    billedYearly: 'Виставлений щорічно',
    day: 'день',
    desc: 'Порівняйте плани та виберіть найкраще',
    detailedCompare: 'Порівняйте плани',
    discount: 'Знижка 20%',
    enterprise: {
      benefit1: 'Пріоритетна підтримка клієнтів',
      benefit2: 'Кілька користувачів',
      benefit3: 'Індивідуальні рішення',
      benefit5: 'Відданий менеджер облікових записів',
      btn: 'Зв’яжіться з нами',
      recommendText: 'Спеціальні плани （≥3 人）',
      talkToUs: 'Зв’яжіться',
    },
    free: {
      benefit1: 'Миттєвий переклад 100 разів/добу',
      benefit2: 'Переклад та резюме веб -сайту',
      benefit3: '30 перекладів зображення',
      benefit4: 'Переклад та резюме відео',
      benefit5: '10 перекладів PDF',
      benefit6: '5000 жетонів',
      btn: 'Спробуйте безкоштовно',
      recommendText: 'Безкоштовна пробна версія',
    },
    imageTranslation: 'Переклад зображення',
    month: 'місяць',
    monthly: 'Щомісяця',
    pageTitle: 'Ціноутворення',
    pdf: { chat: 'PDF Чат -запити', maxPage: 'Макс. Сторінки на PDF', translation: 'Переклад PDF' },
    preMonth: 'На місяць',
    pro: {
      benefit1: 'Пріоритетна підтримка клієнтів',
      benefit2: '1 000 000 жетонів/місяць',
      benefit3: 'Переклад та резюме веб -сайту',
      benefit4: '200 перекладів зображень',
      benefit5: 'Переклад та резюме відео',
      benefit6: '200 перекладів PDF',
      btn: 'Розпочати',
      recommendText: 'Найпопулярніший',
    },
    proPlus: {
      benefit1: 'Пріоритетна підтримка клієнтів',
      benefit2: '3 000 000 жетонів/місяць',
      benefit3: 'Переклад та резюме веб -сайту',
      benefit4: '500 перекладів зображень',
      benefit5: 'Переклад та резюме відео',
      benefit6: '500 PDF перекладів',
      recommendText: 'Найкраще значення',
    },
    video: { summary: 'Резюме відео', translation: 'Переклад відео' },
    web: {
      contrastiveTranslation: 'Двомовний переклад',
      dictionaryTranslation: 'Переклад відбору',
      hoverTranslation: 'Переклад наведення',
      instantTranslation: 'Миттєвий переклад',
      summary: 'Підсумок веб -сторінок',
    },
    yearly: 'Щорічно',
  },
  privacy: {
    block1:
      'Ноам ("Ноам", "ми", "Наші" або "ми") поважає вашу конфіденційність і прагне захистити будь -яку інформацію, яку ми отримуємо від вас чи про вас. Ця Політика конфіденційності описує нашу практику щодо збору чи використання особистої інформації з використання нашого веб -сайту, додатків та послуг (спільно, "Послуги"). Ця Політика конфіденційності не стосується вмісту, який ми обробляємо від імені наших клієнтів бізнес -продуктів, таких як наш API. Використання цих даних підлягає нашій угоді про клієнта, яка охоплює доступ до цих продуктів та використання.',
    block10:
      "Ми впроваджуємо комерційно розумні технічні, адміністративні та організаційні заходи щодо захисту особистої інформації в Інтернеті та офлайн від втрат, неправильного використання та несанкціонованого доступу, розкриття інформації, змін чи ворожих актів. Однак жодна передача в Інтернеті чи електронна пошта не може гарантувати повну безпеку чи точність. Зокрема, електронні листи, надіслані нам або від нас, можуть не бути захищеними. Отже, ви повинні бути особливо обережними, вирішуючи, яку інформацію надсилати нам через послугу чи електронну пошту. Крім того, ми не несемо відповідальності за будь -які перешкоди налаштувань конфіденційності чи заходів безпеки в сервісі або параметрах безпеки сторонніх веб -сайтів або заходах безпеки. Ми зберігатимемо вашу особисту інформацію до тих пір, наскільки це необхідно, щоб нам надати вам послуги або для інших законних ділових цілей, таких як вирішення суперечок, міркувань безпеки та безпеки або виконання наших юридичних зобов'язань. Тривалість часу, коли ми зберігаємо особисту інформацію, залежатиме від багатьох факторів, таких як кількість, природа, чутливість інформації, потенційні ризики несанкціонованого використання або розкриття, цілі, для яких ми обробляємо інформацію, та інші юридично обов'язкові міркування.",
    block11:
      'Ми можемо час від часу оновлювати цю Політику конфіденційності. Коли ми це зробимо, ми опублікуємо оновлену версію на цій сторінці, якщо інше не вимагається чинним законодавством.',
    block12:
      'Якщо у вас є якісь питання без відповіді щодо цієї Політики конфіденційності, зверніться до нашої служби обслуговування клієнтів. Електронна пошта:',
    block2: 'Ми збираємо таку особисту інформацію ("Особиста інформація"), пов’язану з вами:',
    block3:
      'Інформація, що надається вами: Коли ви створюєте обліковий запис для використання наших послуг або спілкування з нами, ми збираємо особисту інформацію так:',
    block4:
      'Особиста інформація автоматично отримана від використання послуг: Коли ви отримуєте доступ, використовуєте або взаємодієте з Послугами, ми отримуємо таку інформацію про ваш доступ, використання або взаємодію ("Технічна інформація"):',
    block5: 'Ми можемо використовувати особисту інформацію для таких цілей:',
    block6:
      "Підсумкова або де-ідентифікована інформація: Ми можемо об'єднати або визначити особисту інформацію, щоб запобігти її повторному використанню для ідентифікаційних цілей та використовувати таку інформацію для аналізу ефективності наших послуг, вдосконалення та додавання функцій до наших послуг, проведення досліджень та для подібних цілей. Крім того, ми можемо проаналізувати загальну поведінку та характеристики наших користувачів послуг та обмінюватися сукупною інформацією з третіми сторонами, публікувати таку сукупну інформацію або зробити її загалом доступною. Ми можемо збирати сукупну інформацію через послуги, через файли cookie та інші засоби, описані в цій Політиці конфіденційності. Ми будемо підтримувати та використовувати де-ідентифіковану інформацію в анонімній або де-ідентифікованій формі, і ми не будемо намагатися повторно ідентифікувати таку інформацію, якщо не вимагається законодавством.",
    block7:
      'У певних випадках ми можемо надати вашу особисту інформацію третім сторонам без подальшого повідомлення, якщо не вимагається законодавством:',
    block8:
      'Залежно від вашого географічного розташування, люди в Європейському економічному районі, Великобританія та в усьому світі можуть мати певні законодавчі права щодо їх особистої інформації. Наприклад, ви можете мати право:',
    block9:
      'Сервіс може містити посилання на інші веб -сайти, які не керуються та не контролюються NOAM, включаючи послуги соціальних медіа ("веб -сайти третьої сторони"). Інформація, якою ви ділитесь із сторонні веб -сайти, регулюється конкретною політикою конфіденційності та умовами обслуговування веб -сайтів третьої сторони, а не цією Політикою конфіденційності. Ми надаємо ці посилання для зручності і не передбачаємо наше схвалення чи огляд цих веб -сайтів. Будь ласка, зверніться до сторонніх веб -сайтів безпосередньо для отримання інформації про їх політику та умови конфіденційності.',
    subBlock1:
      'Інформація про обліковий запис: Коли ви створюєте обліковий запис на нашій платформі, ми збираємо інформацію, пов’язану з вашим обліковим записом, включаючи ваше ім’я, контактну інформацію, облікові дані, інформацію про платіжні картки та історію транзакцій ("Інформація про обліковий запис").',
    subBlock10: 'Надання, управління, підтримання та/або аналіз послуг;',
    subBlock11: 'Спілкування з вами;',
    subBlock12: 'Розробка нових продуктів та послуг;',
    subBlock13:
      'Запобігання шахрайству, злочинній діяльності чи зловживанню нашими послугами та захисту безпеки наших ІТ -систем, архітектури та мереж;',
    subBlock14: 'Проведення бізнес -переказів;',
    subBlock15:
      'Дотримання юридичних зобов’язань та судового розгляду, захисту наших прав, конфіденційності, безпеки чи майна, а також прав на наші філії, ви чи інші треті сторони.',
    subBlock16:
      'Постачальники та постачальники послуг: Щоб допомогти нам у задоволенні оперативних потреб бізнесу та виконанні певних послуг та функцій, ми можемо надати особисту інформацію постачальникам та постачальникам послуг, включаючи постачальників послуг хостингу, постачальників хмарних послуг та іншим постачальникам послуг інформаційних технологій, програмним забезпеченням електронної пошти та постачальниками веб -аналітики та ін.',
    subBlock17:
      'Бізнес -трансферти: Якщо ми беремо участь у стратегічних операціях, реорганізаціях, банкрутствам, порушеннях банкрутства чи переходу послуг до іншого постачальника (колективно, "транзакції"), ваша особиста інформація та інша інформація можуть ділитися з колегами з транзакцій та іншими сторонами, що сприяють транзакціям під час належної ретельності та передачі в рамках транзакцій разом із іншими активами до наступної компанії.',
    subBlock18:
      "Юридичні вимоги: ми можемо поділитися вашою особистою інформацією з державними органами, однолітками галузі чи іншими третіми сторонами, включаючи вашу інформацію про взаємодію з нашими послугами, (1), якщо цього вимагає законодавство, або якщо ми вважаємо, що такі дії необхідні для виконання юридичних зобов'язань; (2) захищати та захищати наші права чи майно; (3) якщо ми в односторонньому порядку визначимо, що існує порушення наших умов, політики чи законів; (4) виявити або запобігти шахрайству чи іншій незаконній діяльності; (5) захищати наші продукти, працівники чи користувачі, або громадську безпеку, безпеку, цілісність; або (vi) захищати від юридичної відповідальності.",
    subBlock19: 'Доступ до вашої особистої інформації та інформації про те, як вона обробляється.',
    subBlock2:
      'Вміст користувача: Коли ви використовуєте наші служби, ми збираємо особисту інформацію з ваших входів, завантаження файлів або відгуків, наданих нам ("вміст").',
    subBlock20: 'Попросіть видалення вашої особистої інформації з наших записів.',
    subBlock21: 'Виправити або оновити свою особисту інформацію.',
    subBlock22: 'Перенесіть свою особисту інформацію третьій стороні (портативність даних).',
    subBlock23: 'Обмежте, як ми обробляємо вашу особисту інформацію.',
    subBlock24:
      'Зняти згоду - де ми покладаємось на згоду як юридичну основу для обробки, ви можете зняти свою згоду в будь -який час.',
    subBlock25: 'Заперечувати, як ми обробляємо вашу особисту інформацію.',
    subBlock26: 'Вдосконалення наших послуг та проведення досліджень;',
    subBlock3:
      'Інформація про спілкування: Якщо ви надсилаєте нам повідомлення, ми збираємо ваше ім’я, контактну інформацію та вміст ваших повідомлень ("інформація про спілкування").',
    subBlock4:
      'Інформація про соціальні медіа: У нас є сторінки на веб -сайтах соціальних медіа, таких як Instagram, Facebook, Medium, Twitter, YouTube та LinkedIn. Коли ви взаємодієте з нашими сторінками соціальних медіа, ми збираємо особисту інформацію, яку ви вирішили надати нам, наприклад, ваші контактні дані ("соціальна інформація"). Крім того, компанії, що приймають наші сторінки соціальних медіа, можуть надати нам сукупну інформацію та аналіз про нашу діяльність у соціальних мережах.',
    subBlock5:
      'Дані журналу: Інформація автоматично надсилається вашим браузером під час використання наших служб. Дані журналу включають вашу адресу Інтернет -протоколу (IP), тип браузера та налаштування, дату та час ваших запитів та те, як ви взаємодієте з нашим веб -сайтом.',
    subBlock6:
      "Дані про використання: Ми можемо автоматично збирати інформацію про ваше використання послуги, наприклад, типи вмісту, з яким ви переглядаєте або взаємодієте, функції, якими ви користуєтесь, дії, які ви вживаєте, а також ваш часовий пол, країна, дата та час доступу, агент користувача та версія, тип комп'ютера чи мобільного пристрою та підключення комп'ютера.",
    subBlock7:
      "Інформація про пристрій: Сюди входить ім'я пристрою, операційну систему, ідентифікатор пристрою та браузер, який ви використовуєте. Зібрана інформація може залежати від типу пристрою, який ви використовуєте, та його налаштувань.",
    subBlock8:
      'Файли cookie: Ми використовуємо файли cookie для роботи та управління нашими послугами та вдосконалення вашого досвіду. "Куки" - це інформація, надіслана веб -сайтом, який ви відвідуєте у своєму браузері. Ви можете встановити свій браузер, щоб прийняти всі файли cookie, відхилити всі файли cookie або повідомити вас, коли надається файл cookie, щоб ви могли вирішити, чи приймати його щоразу. Однак відмова від файлів cookie може заважати вам використовувати або негативно впливати на дисплей або функціональність певних областей або функцій Веб -сайту. Для отримання додаткової інформації про файли cookie, будь ласка, відвідайте все про печиво.',
    subBlock9:
      'Analytics: Ми можемо використовувати різні продукти в Інтернеті, які використовують файли cookie, щоб допомогти нам проаналізувати, як користувачі використовують наші послуги та вдосконалюють ваш досвід під час використання послуг.',
    subTitle1: 'Особиста інформація, яку ми збираємо',
    subTitle2: 'Як ми використовуємо особисту інформацію',
    subTitle3: 'Розкриття особистої інформації',
    subTitle4: 'Ваші права',
    subTitle5: 'Посилання на інші веб -сайти',
    subTitle6: 'Безпека та збереження інформації',
    subTitle7: 'Модифікація політики конфіденційності',
    subTitle8: 'Як зв’язатися з нами',
    title: 'Політика конфіденційності',
    updateTime: 'Оновлено: 15 березня 2024 року',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Прийняти все',
    text: 'Для покращення вашого досвіду ми використовуємо файли cookie для персоналізації вмісту та послуг.',
    title: 'Цей веб -сайт використовує файли cookie',
  },
  slogen: 'Найпростіший асистент AI',
  stripe: {
    contact: 'Зверніться до нас за адресою contact@noam.tools з будь -якими питаннями!',
    fail: {
      btn: 'Повторити',
      text1: 'Ми не змогли обробити ваш платіж.',
      text2: "Перевірте своє з'єднання та повторіть спробу.",
      title: 'Оплата не вдалося',
    },
    succ: {
      btn: 'Підемо',
      text1: 'Ласкаво просимо до Ноама,',
      text2: 'Почнемо!',
      title: 'Вітаємо',
    },
  },
  terms: {
    block1: 'Дякую за використання Ноама!',
    block10:
      '(a) Плата і виставлення рахунків. Ви сплатите всі збори ("збори") відповідно до ціни та умов на відповідній сторінці ціноутворення або, як це було домовлено в письмовій формі між нами. Ми залишаємо за собою право виправити помилки чи помилки ціноутворення, навіть якщо ми видавали рахунки -фактури або отримали платіж. Ви надасте повну та точну платіжну інформацію, включаючи дійсне та уповноважений метод оплати. Ми стягуватимемо ваш метод оплати періодично, як домовлено, але ми можемо обґрунтовано змінити дату виставлення рахунків. Ви уповноважуєте Noam, його філії та сторонні платіжні процесори для стягнення з вашого методу оплати. Якщо ваш платіж не вдасться, ми надамо вам письмове повідомлення і можемо призупинити доступ до послуги до отримання платежу. За винятком випадків, зазначених у цій Угоді, виплати не підлягають поверненню.',
    block11:
      '(b) податки. Якщо не зазначено інше, збори не включають жодних федеральних, державних, місцевих та іноземних податків, обов\'язків та подібних оцінок ("податки"). Ви несете відповідальність за всі податки, пов’язані з вашими покупками, за винятком податків на основі нашого чистого доходу, на який ми будемо виставляти рахунок. Ви погоджуєтесь негайно сплатити такі податки та надати нам юридично дійсні звіти про конфіденційність та отримати необхідні згоди на обробку таких даних, і ви гарантуєте нам, що ви обробляєте такі дані відповідно до чинного законодавства.',
    block12:
      '(c) Зміни цін. Ми можемо змінити наші ціни, повідомивши вас через ваш рахунок та/або наш веб -сайт. Збільшення цін буде набратися негайно після розміщення. Будь -які зміни цін застосовуватимуться до плати за ваш рахунок після дати набрання чинності змін.',
    block13:
      "(d) суперечки та прострочені платежі. Якщо ви хочете оскаржити будь -які збори чи податки, будь ласка, зв'яжіться з contact@noam.tools протягом тридцяти (30) днів після дати рахунку -фактури.",
    block14:
      '(e) Безкоштовне використання. Ви не можете створювати кілька облікових записів для отримання безкоштовних кредитів. Якщо ми визначимо, що ви не використовуєте безкоштовні кредити добросовісно, ​​ми можемо стягувати з вас стандартні збори або припинити надавати доступ до послуги.',
    block15:
      "(а) конфіденційність. Ви можете мати доступ до конфіденційної інформації Noam. Ви можете використовувати конфіденційну інформацію, дозволену за цими умовами з метою використання послуги. Ви не можете розголошувати конфіденційну інформацію будь -якій третій стороні, і ви захищаєте конфіденційну інформацію таким чином, щоб не менш захисним, ніж захищати власну подібну конфіденційну інформацію, принаймні з розумною допомогою. Конфіденційна інформація-це непублічна інформація, визначена як конфіденційна NOAM, або що слід обґрунтовано розглядати як конфіденційну за обставин, включаючи програмне забезпечення, технічні характеристики та іншу непублічну ділову інформацію. Конфіденційна інформація не містить інформації про те, що: (1) стає загально доступним для громадськості без вини з вашого боку; (2) Ви мали у своєму розпорядженні без будь -яких зобов'язань щодо конфіденційності, перш ніж отримувати її за цими умовами; (3) законно розголошується вам третьою стороною без будь -яких зобов'язань щодо конфіденційності; або (4) незалежно розроблений вами без використання конфіденційної інформації. Ви можете розголошувати конфіденційну інформацію, якщо цього вимагає законодавство, суд чи інший урядовий наказ, але ви повинні надати попереднє письмове повідомлення NOAM розумним чином і, наскільки це можливо, докладати розумних зусиль для обмеження обсягу розкриття інформації, включаючи допомогу нам у протилежних запитах щодо розкриття інформації.",
    block16:
      '(b) безпека. Ви повинні реалізувати розумні та відповідні заходи, щоб допомогти захистити ваш доступ до послуги та користуватися послугою. Якщо ви виявите будь -які вразливості чи порушення, пов’язані з вашим використанням Сервісу, ви повинні негайно зв’язатися з Ноам та надати детальну інформацію про вразливість чи порушення.',
    block17:
      '((c) Обробка персональних даних. Якщо ви використовуєте послугу для обробки персональних даних, ви повинні надати юридично достатні заяви про конфіденційність та отримати необхідні згоди на обробку таких даних, і ви гарантуєте нам, що ви обробляєте такі дані відповідно до чинного законодавства.',
    block18:
      '(a) припинення; Підвіска. Ці умови будуть чинними при вашому першому використанні послуги та залишатимуться в силі до припинення. Ви можете припинити ці Умови в будь -який час з будь -якої причини, припиняючи використання послуги та вмісту. Ми можемо припинити ці Умови з попереднім повідомленням з будь -якої причини. Ми можемо негайно припинити ці Умови, повідомляючи вас, якщо ви істотно порушуєте розділ 2 (вимоги щодо використання), розділ 5 (конфіденційність, безпека та захист даних), розділ 8 (вирішення спорів) або розділ 9 (загальні терміни), або якщо наші стосунки з будь-якими сторонніми технологіями, що перебувають поза нашими змінами контролю, або для дотримання законодавства чи державних запитів. Ми можемо призупинити ваш доступ до послуги, якщо ви не дотримуєтесь цих умов, або якщо ваше використання становить ризик для безпеки для нас або будь -якої третьої сторони, або якщо ми підозрюємо, що ваше використання є шахрайським або може піддавати нас або будь -якій третій стороні відповідальності.',
    block19:
      '(b) Ефекти припинення. Після припинення ви припините користуватися послугою та негайно повернути або знищити будь -яку конфіденційну інформацію відповідно до нас. Положення цих термінів, які за своєю природою повинні переживати припинення чи закінчення терміну дії, включаючи, але не обмежуючись ними, розділи 3 та 5-9, виживають.',
    block2:
      'Ці Умови використання застосовуються до використання послуг NOAM, включаючи наші інтерфейси програмування додатків, програмне забезпечення, інструменти, служби розробників, дані, документацію та веб -сайт (спільно називаються "послугами"). Використовуючи наші послуги, ви погоджуєтесь дотримуватися цих умов. Наша політика конфіденційності пояснює, як ми збираємо та використовуємо особисту інформацію.',
    block20:
      "(а) відшкодування. Ви будете захищати, відшкодувати та утримувати нас, наші філії та наш персонал нешкідливий від та проти будь -яких вимог, втрат та витрат (включаючи адвокатські збори), що виникають із використання послуги або пов'язані з вашим використанням, включаючи ваш вміст, використання продуктів або послуг, пов’язаних із послугою, та вашого порушення цих умов або застосовуваного закону.",
    block21:
      '(b) Відмова. Послуга надається "як є". Наскільки це дозволено законодавством, ми та наші філії та ліцензіари не надають жодних гарантій та гарантій щодо послуги та не здійснюють гарантій, включаючи, але не обмежуючись гарантіями товарності, пристосування для певної мети, задовільної якості, не порушення та спокійної насолоди та будь-яких гарантій, що виникають у справі про торгівлю. Ми не гарантуємо, що послуга буде безперебійною, точною або без помилок, або що будь-який вміст буде захищений, не втрачений або не змінений.',
    block22:
      '(c) Обмеження відповідальності. Ні ми, наші філії, ані наші ліцензіари не несе відповідальності за будь -які непрямі, випадкові, особливі, наслідкові чи каральні збитки, включаючи втрату прибутку, втрату репутації, втрату використання, втрату даних або інші нематеріальні втрати, навіть якщо нам порадили можливість такої шкоди. Згідно з цими умовами, наша загальна відповідальність не перевищує збори, які ви сплатили послугу за дванадцять (12) місяців, що передували вимозі, або сто доларів США (100 доларів), залежно від того, що більше. Обмеження в цьому розділі застосовуються максимально, дозволеною чинним законодавством.',
    block23:
      'Терміни та ваше використання Послуг регулюються законами Сполучених Штатів, за винятком Правил законів про конфлікт законів. Ваше використання заявки також може бути підпадає під дію інших місцевих, державних, національних чи міжнародних законів. Будь -яка юридична дія або провадження, що стосуються цих Умов, будуть висунуті виключно до судів США, і ви погоджуєтесь подати особисту юрисдикцію таких судів.',
    block24:
      "(a) Зв'язок сторін. Ноам і ви є незалежними підрядниками, і жодна із сторін не має повноважень представляти або прив’язувати іншу сторону або брати на себе зобов’язання для іншої сторони без попередньої письмової згоди іншої сторони.",
    block25:
      "(b) Використання бренду. Ви не можете використовувати ім'я, логотипи чи торгові марки NOAM або будь -яких його філіїв без нашої попередньої письмової згоди.",
    block26:
      'Якщо будь -яке положення цих Умов визначено як недійсне, незаконне або невиконане, решта положень залишатимуться в повній силі та ефекті.',
    block3:
      "Якщо вам не виповнилося 18 років, ви повинні отримати дозвіл від батьків або законних опікунів на використання послуги. Якщо ви використовуєте Службу від імені іншої особи чи суб'єкта господарювання, ви повинні бути уповноважені прийняти ці умови від їх імені. Ви повинні надати точну та повну інформацію для реєстрації для облікового запису. Ви не можете надати свої облікові дані або обліковий запис будь -кому поза вашою організацією, і ви несете відповідальність за всі заходи, проведені за допомогою ваших облікових даних.",
    block4:
      '(a) Використання сервісу. Ви можете отримати доступ до Сервісу за цими умовами, і ми надаємо вам неексклюзивне право користуватися послугою. Використовуючи послугу, ви будете дотримуватися цих умов та всіх застосовних законів. Ми та наші філії володіють усіма правами, титулами та інтересами в службі.',
    block5:
      "(b) Зворотній зв'язок. Ми вітаємо відгуки, коментарі, ідеї, пропозиції та вдосконалення. Якщо ви надаєте будь -який такий вміст, ми можемо використовувати його без будь -яких обмежень і без компенсації для вас.",
    block6:
      '(c) Обмеження. Ви не можете: (1) використовувати послугу таким чином, що порушує, присвоєні або порушує будь -які права інших; (2) реверс -інженер, декомпілювати, розбирати, перекласти чи іншим чином намагатися виявити вихідний код або основні компоненти моделей обслуговування, алгоритмів та систем (якщо такі обмеження не заборонені застосовним законодавством); (3) Використовуйте вихід Сервісу для розробки моделей, що конкурують з NOAM; (4) витягувати дані або вихід із служби за допомогою будь -яких автоматизованих або методів програмування, якщо це не дозволено через API, включаючи вискоблювання, веб -збирання або вилучення веб -даних; (5) представляти вихід послуги як штучно генерується, коли її немає, або іншим чином порушують нашу політику використання; (6) купувати, продати або переказувати ключі API без нашої попередньої згоди; або (7) надати нам будь -яку особисту інформацію дітей до 13 років або застосовного віку цифрової згоди. Ви будете дотримуватися будь -яких обмежень та інших вимог у нашій документації.',
    block7:
      '(d) сторонні послуги. Будь-яке стороннє програмне забезпечення, послуги чи інші продукти, пов’язані зі Сервісом, регулюються власними умовами, і ми не несемо відповідальності за сторонні продукти.',
    block8:
      '(a) Ваш вміст. Ви можете надати вхід ("вхід") до служби та отримувати вихід ("вихід"), створений та повернутий на основі входу (спільно називають "вмістом"). Між сторонами та в міру дозволу чинного законодавства ви володієте всіма вкладами. Noam може використовувати вміст для надання та підтримки послуги, дотримання чинних законів та виконання нашої політики. Ви несете відповідальність за вміст, включаючи забезпечення того, що він не порушує жодних чинних законів чи цих умов.',
    block9:
      '(b) Точність. Штучний інтелект та машинне навчання швидко розвиваються сфери досліджень. Ми постійно прагнемо вдосконалити свою послугу, щоб зробити його більш точним, надійним, безпечним та корисним. Враховуючи ймовірний характер машинного навчання, використання нашої служби може призвести до неправильних результатів у певних випадках, що може не точно відображати реальних людей, місць чи фактів. Ви повинні належним чином оцінити точність будь -якого виходу на основі вашого випадку використання, в тому числі шляхом перегляду результатів вручну.',
    subTitle1: 'Реєстрація та доступ',
    subTitle10: 'Розтяжність',
    subTitle2: 'Вимоги до використання',
    subTitle3: 'Зміст',
    subTitle4: 'Збори та оплата',
    subTitle5: 'Конфіденційність, безпека та захист даних',
    subTitle6: 'Термін і припинення',
    subTitle7: 'Відшкодування збитків; Відмова; Обмеження відповідальності',
    subTitle8: 'Керуючий закон та юрисдикція',
    subTitle9: 'Загальні умови',
    title: 'Умови обслуговування',
    updateTime: 'Оновлено: 15 березня 2024 року',
  },
  trialModal: {
    btn: 'Почніть зараз （лише $ 0,99）',
    chat: 'Чатпдф',
    desc1: 'Після судового розгляду вам стягується щорічна плата в розмірі 180 доларів',
    desc2: 'Скасувати в будь -який час',
    focus: 'Фокусування',
    hover: 'Переклад наведення',
    image: 'Переклад зображення',
    installBtn: 'Встановіть зараз, щоб отримати свій подарунок',
    memo: 'Управління улюбленими',
    pdf: 'PDF Паралельний переклад',
    realtime: 'Миттєвий переклад',
    select: 'Переклад відбору слів',
    title: 'Ласкаво просимо подарунок',
    trialText: '7-денне суд',
    video: 'Переклад відео',
    videoSummary: 'Резюме відео',
    web: 'Паралельний переклад',
    webSummary: 'Веб -резюме',
  },
  upgradeModal: {
    btn: 'Оновлення зараз',
    chat: { free: 'Ви дійшли до ліміту CHATPDF', pro: 'Ви дійшли до ліміту чату на цей місяць' },
    contactStr:
      "Зачекайте наступного скидання або зв'яжіться з нами за адресою contact@noam.tools.",
    limitAlertStr: 'Ви досягли свого вільного ліміту плану. Оновлення для продовження.',
    more: 'Переглянути плани',
    pageLimit: { free: 'Ви дійшли до ліміту сторінки PDF' },
    title: 'Нагадування',
    upgradeAlertStr: 'Ви досягли свого вільного ліміту плану. Оновлення для продовження.',
    upload: {
      free: 'Ви досягли свого ліміту перекладу PDF',
      pro: 'Ви досягли свого ліміту перекладу PDF за цей місяць',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Приєднуйтесь зараз',
      label: 'Нові переваги користувача:',
      remain: 'Залишилося лише 30',
      text: 'Доступно лише 100 плям! Візьміть своє зараз!',
    },
  },
  aiPdfTranslator: {
    title: 'Безкоштовний AI PDF Перекладач: Перекладайте PDF з порівнянням на будь-яку мову',
    desc: 'Легко перекладайте PDF-файли на будь-яку мову за допомогою AI. Порівнюйте оригінальний та перекладений текст поруч, швидко та безкоштовно.',
    keywords: 'GPT-4, AI-асистент, Переклад, Резюме, Фокус, ChatPDF, Нотатка, Ефективність',
    sourceToTarget: {
      title:
        'Безкоштовний інструмент перекладу PDF: перекладайте з {{source}} на {{target}} безкоштовно',
      desc: 'Перекладайте PDF-файли з будь-якої мови оригіналу на бажану мову безкоштовно. Швидкий, точний і безпечний переклад PDF за допомогою сучасного штучного інтелекту.',
    },
    headerIntroduce: {
      title: 'Noam: Більше, ніж просто онлайн-перекладач',
      introduce1: {
        title: 'Noam · PDF Читач',
        desc: '✨Покроковий переклад + AI Q&A. Швидко та точно перекладайте PDF на вашу мову. Вільно ставте запитання про зміст для глибшого розуміння ваших PDF.',
      },
      introduce2: {
        title: 'Noam · Розширення для покрокового перекладу',
        desc: '👏Вирішіть усі свої потреби у перекладі веб-сторінок:',
        detail1: { title: 'Переклад веб-сторінок: ', desc: 'Покроковий двомовний перегляд.' },
        detail2: { title: 'Переклад слів: ', desc: 'Швидкий переклад одним кліком.' },
        detail3: { title: 'Миттєвий переклад: ', desc: 'Миттєвий переклад слів чи речень.' },
        detail4: { title: 'Переклад зображень: ', desc: 'Замінюйте зображення перекладеними.' },
        detail5: { title: 'Переклад відео: ', desc: 'Двомовні субтитри для зручного перегляду.' },
        footer: 'Спробуйте більше функцій читання на основі AI для розумнішого перекладу!',
      },
    },
    subtitle: 'Онлайн переклад PDF безкоштовно',
    introduce: {
      module1: {
        detail1: {
          title: 'Переклад PDF у реальному часі покроково',
          desc1:
            'Миттєво показуйте оригінальний та перекладений вміст у синхронізованому покроковому режимі',
          desc2: 'Легко порівнюйте обидві версії за допомогою синхронізованої прокрутки',
          desc3: 'Зберігайте однакове форматування для зручного читання',
        },
        detail2: {
          title: 'Точне вирівнювання та перевірка вмісту',
          desc1: 'Ідеальне вирівнювання між джерелом і перекладом для легкої перевірки',
          desc2: 'Кожен сегмент вмісту точно відповідає в обох версіях',
          desc3: 'Швидко знаходьте й виправляйте розбіжності у перекладі для надійних результатів',
        },
      },
      module2: {
        detail1: {
          title: 'Кілька сучасних AI-моделей для точного перекладу',
          desc1: 'Вибирайте провідні AI-моделі для відповідності вашим перекладацьким вимогам',
          desc2: 'Гарантуйте найкращі результати для різних типів документів і галузей',
          desc3: 'Гнучкі опції моделей забезпечують індивідуальні рішення для кожної ситуації',
        },
        detail2: {
          title: 'Передовий AI-переклад для будь-якого типу вмісту',
          desc1: 'Наш потужний AI гарантує високу точність і розуміння природної мови',
          desc2: 'Легко працює з технічними, академічними та творчими документами',
          desc3: 'Забезпечує надійний результат для всіх ваших перекладацьких потреб',
          desc4: 'Інтелектуально адаптується до різних типів вмісту для оптимальної роботи',
        },
      },
      module3: {
        detail1: {
          title: 'Інтелектуальна взаємодія з документами',
          desc1: 'Легко спілкуйтеся зі своїми PDF і презентаціями за допомогою AI',
          desc2: 'Миттєво задавайте питання про зміст документу та отримуйте точні відповіді',
          desc3: 'Швидко створюйте короткі резюме для довгих документів',
        },
        detail2: {
          title: 'Глибокий аналіз вмісту та безшовна інтеграція',
          desc1: 'Виділяйте ключову інформацію та аналізуйте складні дані за допомогою AI',
          desc2: 'Отримуйте розуміння технічних, академічних чи креативних матеріалів',
          desc3:
            'Безшовно інтегрується з нашим PDF-перекладачем для повного управління документами',
        },
      },
      module4: {
        detail1: {
          title: 'Більше, ніж переклад PDF: Універсальне рішення для перекладу веб-сторінок',
          desc: 'Відкрийте для себе наш потужний покроковий розширювач перекладу для будь-якої ситуації онлайн-чтення.',
          desc1:
            'Переклад веб-сторінок: Насолоджуйтеся двомовним вмістом із синхронізованим покроковим переглядом',
          desc2: 'Переклад слів: Миттєво перекладайте виділені слова одним кліком',
          desc3:
            'Миттєвий переклад: Перекладайте будь-який текст чи речення одразу для швидкого розуміння',
          desc4: 'Переклад зображень: Автоматично замінюйте оригінальні зображення перекладеними',
          desc5: 'Переклад відео: Дивіться відео з двомовними субтитрами для кращого досвіду',
        },
      },
    },
    question: {
      title: 'Поширені запитання',
      answer1: {
        title: 'Чи безкоштовний Noam PDF Translator для перекладу PDF?',
        content:
          'Так, ви можете безкоштовно перекладати PDF за допомогою Sider PDF Translator! Ми надаємо безкоштовну квоту в 5 000 токенів, що достатньо для перекладу більшості PDF-документів на ринку. Якщо вам потрібно перекласти більші файли чи скористатися розширеними функціями, ви можете оновити тарифний план для ще більших можливостей.',
      },
      answer2: {
        title: 'Яка точність перекладу Noam PDF Translator?',
        content:
          'Noam PDF Translator забезпечує дуже точний переклад, використовуючи сучасні AI-технології та глибоке розуміння контексту ваших документів. Хоча жоден автоматичний переклад не є ідеальним, наш покроковий режим дозволяє легко перевірити та виправити будь-який переклад, щоб фінальний результат відповідав вашим очікуванням щодо якості. Відчуйте надійний та точний переклад PDF з Noam.',
      },
      answer3: {
        title: 'Чи можна перекладати скановані PDF?',
        content:
          'Так, ви можете перекладати скановані PDF за допомогою вбудованої технології OCR (Оптичне Розпізнавання Символів). Наша система автоматично витягує текст зі сканованих документів і PDF на основі зображень, а потім перекладає для вас вміст. Це гарантує точний переклад навіть для недоступних для редагування або тільки зображень PDF.',
      },
      answer4: {
        title: 'Скільки часу займає переклад?',
        content:
          'Переклад відбувається швидко та ефективно — більшість документів обробляється за кілька секунд або хвилин, залежно від їхньої довжини й складності. Наприклад, стандартний 10-сторінковий PDF зазвичай перекладається менш ніж за 2 хвилини. Насолоджуйтесь швидким виконанням усіх ваших потреб у перекладі документів!',
      },
      answer5: {
        title: 'Чи можу я залишити покроковий перегляд для читання?',
        content:
          'Так, ви завжди можете читати свої документи у покроковому режимі. Такий вигляд дозволяє легко порівнювати оригінал і перекладений вміст, забезпечуючи комфортне й ефективне читання.',
      },
    },
    freeTrial: 'Безкоштовна пробна версія',
    toLanguage: { title: 'Пари AI-перекладу PDF {{lang}}', item: 'з {{source}} на {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'Блог',
      faq: 'Часті запитання',
      button: 'Перекласти зараз',
      pricing: 'Ціноутворення',
      features: 'Властивості',
    },
    hero: {
      upload: {
        title: 'Завантажте свій PDF',
        max: 'Макс',
        highlight: 'Натисніть для перегляду',
        desc: 'або перетягніть та відпустіть',
      },
      to: 'до',
      title: 'Вільний перекладач PDF',
      pill: 'Перекладач PDF на основі штучного інтелекту',
      model: 'GPT-4 та Claude',
      desc: ' миттєві, точні переклади, які зберігають оригінальний макет. Noam AI підтримує OCR та відображення в паралельних вікнах.',
      free: 'Вільна пробна версія',
      translated: 'Перекладено Ноамом',
      complete: 'Переклад завершено',
      support: 'Підтримка OCR',
    },
    ticker: {
      pdf: 'Переклад PDF',
      multi: 'Багатомовний',
      format: 'Збереження формату',
      side: 'Бок о бок',
      ocr: 'Технологія OCR',
      chat: 'Чат з PDF',
      secure: 'Безпечний та приватний',
      web: 'Веб-переклад',
    },
    comparison: {
      bad: {
        title: 'Стандартний переклад',
        head: 'Втрата форматування та контексту',
        text1: 'Помилка: Макет пошкоджений. Зображення поміщені невірно.',
        text2: 'Текст накладається, а шрифти несумісні. Важко читати та не професійно...',
      },
      dump: { title: 'Прості текстові дані' },
      good: {
        title: 'Переклад Noam AI',
        tag: 'Ідеальний результат',
        sub: 'Ідеальне форматування, усвідомлення контексту',
      },
      title: 'Чому обирати Noam AI?',
      desc: 'Припиняйте зусилля з копіюванням та вставкою перекладів. Спробуйте відрізнити стандартні інструменти від нашого AI-посиленого перекладу, що розуміє контекст.',
    },
    showcase: {
      title1: 'Будь-який документ',
      title2: 'Будь-яка мова',
      kicker: 'ПІДТРИМУВАНІ ДОКУМЕНТИ',
      carousel1: 'Мистецтво',
      carousel2: 'Архітектура',
      carousel4: 'Медицина',
      carousel3: 'Науковий журнал',
      note: 'Зручно працюйте з технічними, академічними та творчими документами.',
      carousel6: 'Закон',
      carousel5: 'Фінанси',
      carousel7: 'Договір',
      carousel8: 'Політика',
    },
    features: {
      big: {
        title: 'Розширені моделі штучного інтелекту (GPT-4, Claude)',
        desc: 'Виберіть з провідних моделей штучного інтелекту, щоб задовольнити ваші потреби у перекладі. Забезпечте оптимальні результати для різних типів документів.',
      },
      grid1: {
        title: 'Підтримка OCR',
        desc: ' миттєво витягуйте та перекладаєте текст із відсканованих PDF-файлів та зображень.',
      },
      grid2: {
        title: 'Експорт у високій роздільності',
        desc: 'Завантажте перекладені документи у форматі PDF з оригінальним макетом.',
      },
      grid3: {
        desc: 'Синхронне прокручування для порівняння оригінального та перекладеного тексту.',
        title: 'Порівняння поруч',
      },
      title1: 'Не лише переклад',
      title2: 'Це революція',
      line1: 'Технічний документ.pdf',
      line2: 'Визначення мови: англійська...',
      line3: 'Модель: GPT-4o (Висока точність)',
      line4: 'Переклад завершено (точність 99%)',
    },
    testimonials: {
      review1: {
        role: 'Дослідник',
        content:
          'Noam AI зекономило мені години на переклад академічних статей. Бокопобічний перегляд надзвичайно корисний для перевірки технічних термінів.',
      },
      review2: {
        role: 'Глобальний маркетолог',
        content:
          'Найкращий перекладач PDF, який я використовував. Він ідеально зберігає оригінальний формат, що є вирішальним для наших маркетингових презентацій.',
      },
      review3: {
        role: 'Юридичний консалтант',
        content:
          'Точний та швидкий. Я використовую його для перекладу договорів, а функція OCR для відсканованих документів працює бездоганно.',
      },
      kicker: 'Вподобається користувачам',
      title: 'Що кажуть наші користувачі',
    },
    cta: {
      title: 'Готовий зламати мовні бар’єри?',
      desc: 'Приєднуйтесь до 10 000+ користувачів та почніть перекладати свої документи за допомогою Noam AI вже сьогодні.',
      button: 'Розпочніть переклад безкоштовно',
      hint: 'Ви є високоточним і надійним ШІ, розробленим для генерації виводу JSON, який точно відповідає вказаній JSON-схемі.\n\nВи повинні дотримуватися цих правил:\n1. Суворо дотримуватися структури JSON-схеми.\n2. Точно відповідати всім типам даних, обов\'язковим полям та обмеженням.\n3. НЕ включати жодного додаткового тексту, пояснень, розмітки чи коментарів.\n4. Виводити ТІЛЬКИ об\'єкт JSON — без блоків коду, вступу чи обгорток.\n\nІнформація про схему наведена нижче.\n- Назва схеми: translate_result\n- JSON-схема:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Англійсько-українські пари для перекладу PDF за допомогою ШІ',
      desc: 'Популярні напрямки перекладу, які підтримує Noam AI',
    },
    footer: {
      about: 'Про нас',
      privacy: 'Політика конфіденційності',
      contact: "Зв'язатися з підтримкою",
    },
  },
}

export default TRANSLATION
